// Local skill cooldown bookkeeping (server is authoritative; this is just UI gating).
// PRD 2.4 - keep tick costs predictable.
import { useCooldownStore } from '@/state/cooldownStore';

export class CooldownTracker {
  private next: Map<number, number> = new Map();
  isReady(skillId: number, now = performance.now()): boolean {
    const t = this.next.get(skillId) ?? 0;
    return now >= t;
  }
  arm(skillId: number, cooldownMs: number, now = performance.now()) {
    this.next.set(skillId, now + cooldownMs);
    if (cooldownMs > 0) useCooldownStore.getState().arm(skillId, cooldownMs, now);
  }
  remaining(skillId: number, now = performance.now()): number {
    return Math.max(0, (this.next.get(skillId) ?? 0) - now);
  }
}
